<script>
    import NavbarMenu from './navbar/navbar_menu.svelte';
    import Footer from './landing_page/footer.svelte';
    import Navbar from './navbar/navbar.svelte';
    const {title} = rpcjs.props;
    title.set('Media | Center');
    const blogs = [
        {
            blogsimage: '/images/Blogs/Screen+Shot+2021-10-04+at+8.54.png',
            name: 'Asra Nadeem,',
            date: 'Nov 12, 2021',
            Title: 'Fundamentals of Entrepreneurship Pre-Accelerator Fall 2021 Announces Demo Day Winners',
            like: false,
        },
        {
            blogsimage:
                '/images/Blogs/Christopher+Swenor_1920+x+1080+Thumbnail.png',
            name: 'Asra Nadeem,',
            date: 'Nov 05, 2021',
            Title: 'Blockchain with Christopher Swenor (CEO of Reach)',
            like: false,
        },
        {
            blogsimage: '/images/Blogs/Addie+Wagenknecht+1920+x+1080.png',
            name: 'Asra Nadeem,',
            date: 'Oct 22, 2021',
            Title: 'Talking About the Future of Blockchain with Addie Wagenknecht',
            like: false,
        },
        {
            blogsimage: '/images/Blogs/Algorand+x+Draper+Banner+Image+v2.png',
            name: 'Asra Nadeem,',
            date: 'Sept 14, 2021',
            Title: 'ALGORAND x DRAPER ANNOUNCES 13 BLOCKCHAIN STARTUPS TO JOIN 10-WEEK ACCELERATOR',
            like: false,
        },
        {
            blogsimage: '/images/Blogs/blog-header 1.png',
            name: 'Draper University, ',
            date: ' Nov 10, 2020',
            Title: 'UNDP and Draper University launch impact venture accelerator to scale solutions for COVID-19 recovery',
            like: false,
        },
        {
            blogsimage:
                '/images/Blogs/01-What-is-a-business-incubator-and-how-does-it-work 1.png',
            name: 'Draper University, ',
            date: 'May 22, 2020',
            Title: 'What Is a Business Incubator and How Does It Work?',
            like: false,
        },
    ];
// <!-- Google Tag Manager -->
(function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<header>
    <div class="desktop" style="margin-bottom: 10vw;">
        <Navbar />
    </div>
    <div class="mobile">
        <div style="width:72.6vw;">
            <NavbarMenu
                backgroundColor="white"
                textColor="black"
                btnColor="white"
                btnTextColor="black"
            />
        </div>
    </div>
</header>

<div class="desktop">
    <section style="padding: 7vw 7vw;" class="header">
        <h1 style="font-size:5.291vw;color:#00204B;font-weight:bolder;">
            Media Center <span style="font-size:1.190vw;font-weight:lighter"
                >Read the latest from Draper</span
            >
        </h1>

        <div class="circle-container">
            <div style="display: flex;">
                <div class="circle">
                    <div class="circle-text">
                        Listen to our 
                        <br>
                        Draper University Web 3 podcast
                    </div>
                    <div class = "spotify-div">
                        <iframe style="border-radius:0.661vw" title = '' src="https://open.spotify.com/embed/playlist/37i9dQZF1DX8Uebhn9wzrS?utm_source=generator" width="100%" height="100%" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div style="width:100%;">
            <div class="blog_contnet_holder">
                {#each blogs as data, id}
                    <div class="blog_content_section">
                        <div class="blog-image-wrraper">
                            <img src={data.blogsimage} alt="" width="100%" />
                        </div>
                        <div style="margin:1vw 0">
                            <p style="color:#6B6B6B;font-size:1.058vw;">
                                {data.name}
                                <span>
                                    {data.date}
                                </span>
                            </p>
                        </div>
                        <div style="width: 24.339vw;
                        height: 3.968vw;">
                            <h5
                                style="font-size:1.190vw;color:black;font-weight:600;"
                            >
                                {data.Title}
                            </h5>
                        </div>
                        <div style="display: flex;
                        justify-content: end;
                        margin-top: 0.992vw;">
                            <div
                                style="margin-right: 1vw;"
                                on:click={() => {
                                    if (data.like === false) {
                                        data.like = true;
                                    } else {
                                        data.like = false;
                                    }
                                }}
                            >
                                {#if data.like === false}
                                    <svg
                                        width="1.9vw"
                                        height="1.5vw"
                                        viewBox="0 0 22 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2.21688 10.1999C0.0535382 7.26649 0.774652 2.86642 4.38022 1.39973C7.98579 -0.0669538 10.1491 2.86642 10.8702 4.33311C11.5914 2.86642 14.4758 -0.0669538 18.0814 1.39973C21.687 2.86642 21.687 7.26649 19.5236 10.1999C17.3603 13.1332 10.8702 19 10.8702 19C10.8702 19 4.38022 13.1332 2.21688 10.1999Z"
                                            stroke="black"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                {/if}
                                {#if data.like === true}
                                    <svg
                                        width="1.9vw"
                                        height="1.5vw"
                                        viewBox="0 0 22 20"
                                        fill="#3C74C0"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2.21688 10.1999C0.0535382 7.26649 0.774652 2.86642 4.38022 1.39973C7.98579 -0.0669538 10.1491 2.86642 10.8702 4.33311C11.5914 2.86642 14.4758 -0.0669538 18.0814 1.39973C21.687 2.86642 21.687 7.26649 19.5236 10.1999C17.3603 13.1332 10.8702 19 10.8702 19C10.8702 19 4.38022 13.1332 2.21688 10.1999Z"
                                            stroke="#3C74C0"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                {/if}
                            </div>
                            <div>
                                <svg
                                    width="1.9vw"
                                    height="1.5vw"
                                    viewBox="0 0 16 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M15.4545 8.14737C15.5864 8.14737 15.7137 8.19712 15.813 8.2874C15.9124 8.37769 15.977 8.5024 15.9949 8.63848L16 8.71579V15.1579C16.0001 15.8855 15.7324 16.5854 15.252 17.1134C14.7717 17.6414 14.1154 17.9574 13.4182 17.9962L13.2727 18H2.72727C2.02897 18.0001 1.35726 17.721 0.850534 17.2203C0.343812 16.7196 0.0406928 16.0354 0.00363645 15.3087L0 15.1571V8.71503C0.000225234 8.57108 0.0528534 8.43258 0.147259 8.32749C0.241665 8.2224 0.370817 8.15855 0.508639 8.14883C0.646461 8.13912 0.782687 8.18426 0.889814 8.27514C0.996942 8.36602 1.06699 8.49587 1.08582 8.63848L1.09091 8.71579V15.1579C1.09086 15.59 1.24821 16.006 1.53118 16.3218C1.81414 16.6377 2.20161 16.8298 2.61527 16.8594L2.72727 16.8632H13.2727C13.6874 16.8632 14.0866 16.6992 14.3896 16.4044C14.6927 16.1095 14.8771 15.7057 14.9055 15.2746L14.9091 15.1579V8.71579C14.9091 8.56503 14.9666 8.42045 15.0689 8.31386C15.1711 8.20726 15.3099 8.14737 15.4545 8.14737ZM7.90109 0.0090948L7.94982 0.0022737L8.01236 0L8.056 0.00303154L8.12436 0.0151579L8.17382 0.0295579L8.21745 0.0462317L8.26836 0.0735157L8.30546 0.0977684L8.33309 0.118232L8.38545 0.165979L13.0138 4.98922C13.1117 5.09052 13.1691 5.22668 13.1744 5.3703C13.1798 5.51392 13.1328 5.65434 13.0428 5.76327C12.9528 5.87221 12.8266 5.94159 12.6895 5.95743C12.5524 5.97328 12.4147 5.93442 12.304 5.84867L12.2429 5.79335L8.54545 1.94021V12.1263C8.54545 12.2637 8.49771 12.3964 8.41108 12.4999C8.32444 12.6034 8.20477 12.6708 8.07418 12.6894L8 12.6947C7.86819 12.6947 7.74084 12.645 7.64151 12.5547C7.54217 12.4644 7.47756 12.3397 7.45964 12.2036L7.45455 12.1263V1.94021L3.75709 5.79335C3.66474 5.88961 3.5423 5.94814 3.41204 5.9583C3.28177 5.96845 3.15234 5.92955 3.04727 5.84867L2.98618 5.79335C2.89381 5.6971 2.83764 5.56951 2.8279 5.43376C2.81815 5.29802 2.85548 5.16314 2.93309 5.05364L2.98618 4.98922L7.61455 0.166737L7.69455 0.0985264L7.76364 0.0568421L7.82618 0.0303158L7.90109 0.00985264V0.0090948Z"
                                        fill="black"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
            <div style="text-align:center;margin-top:5vw;">
                <h3 style="margin-top: 5.868vw;
                margin-left: -6.3vw;
                font-size: 1.19vw;
                color: rgb(60, 136, 195);
                font-weight: 600;
                margin-bottom: -3.696vw;">Older Posts</h3>
            </div>
        </div>
    </section>
</div>

<div class="mobile">
    <div class="main-div-mobile">
        <h1
            style="padding-top: 34.167vw;text-align: center;font-size: 8.333vw;color: rgb(0, 32, 75);font-weight: bolder;"
        >
            Media Center
        </h1>
        <p
            style="font-size: 4.444vw;font-weight: lighter;color: rgb(0, 32, 75);text-align: center;padding-bottom: 14.222vw;"
        >
            Read the latest from Draper
        </p>
        <div class = "spotify-div">
            <iframe style="border-radius:4vw" title = '' src="https://open.spotify.com/embed/playlist/37i9dQZF1DX8Uebhn9wzrS?utm_source=generator" width="100%" height="100%" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
        </div>
        <div style="width:100%;padding: 0vw 4vw 15vw 4vw;">
            <div>
                {#each blogs as data, id}
                    <div class="blog_content_section_mobile">
                        <div class="blog-image-wrraper_mobile">
                            <img src={data.blogsimage} alt="" width="100%" />
                        </div>
                        <div style="margin:4vw 0">
                            <p style="color:#6B6B6B;font-size:4.147vw;">
                                {data.name}
                                <span>
                                    {data.date}
                                </span>
                            </p>
                        </div>
                        <div>
                            <h5
                                style="font-size:4.664vw;color:black;font-weight:600;"
                            >
                                {data.Title}
                            </h5>
                        </div>
                        <div style="display:flex;justify-content:end">
                            <div
                                style="width: 2vw;margin-right: 10vw;text-align: end;"
                                on:click={() => {
                                    if (data.like === false) {
                                        data.like = true;
                                    } else {
                                        data.like = false;
                                    }
                                }}
                            >
                                {#if data.like === false}
                                    <svg
                                        width="25"
                                        height="20"
                                        viewBox="0 0 22 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2.21688 10.1999C0.0535382 7.26649 0.774652 2.86642 4.38022 1.39973C7.98579 -0.0669538 10.1491 2.86642 10.8702 4.33311C11.5914 2.86642 14.4758 -0.0669538 18.0814 1.39973C21.687 2.86642 21.687 7.26649 19.5236 10.1999C17.3603 13.1332 10.8702 19 10.8702 19C10.8702 19 4.38022 13.1332 2.21688 10.1999Z"
                                            stroke="black"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                {/if}
                                {#if data.like === true}
                                    <svg
                                        width="25"
                                        height="20"
                                        viewBox="0 0 22 20"
                                        fill="#3C74C0"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2.21688 10.1999C0.0535382 7.26649 0.774652 2.86642 4.38022 1.39973C7.98579 -0.0669538 10.1491 2.86642 10.8702 4.33311C11.5914 2.86642 14.4758 -0.0669538 18.0814 1.39973C21.687 2.86642 21.687 7.26649 19.5236 10.1999C17.3603 13.1332 10.8702 19 10.8702 19C10.8702 19 4.38022 13.1332 2.21688 10.1999Z"
                                            stroke="#3C74C0"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                {/if}
                            </div>
                            <div
                                style="width:2vw;text-align:end; margin-right:10vw;"
                            >
                                <svg
                                    width="26"
                                    height="20"
                                    viewBox="0 0 16 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M15.4545 8.14737C15.5864 8.14737 15.7137 8.19712 15.813 8.2874C15.9124 8.37769 15.977 8.5024 15.9949 8.63848L16 8.71579V15.1579C16.0001 15.8855 15.7324 16.5854 15.252 17.1134C14.7717 17.6414 14.1154 17.9574 13.4182 17.9962L13.2727 18H2.72727C2.02897 18.0001 1.35726 17.721 0.850534 17.2203C0.343812 16.7196 0.0406928 16.0354 0.00363645 15.3087L0 15.1571V8.71503C0.000225234 8.57108 0.0528534 8.43258 0.147259 8.32749C0.241665 8.2224 0.370817 8.15855 0.508639 8.14883C0.646461 8.13912 0.782687 8.18426 0.889814 8.27514C0.996942 8.36602 1.06699 8.49587 1.08582 8.63848L1.09091 8.71579V15.1579C1.09086 15.59 1.24821 16.006 1.53118 16.3218C1.81414 16.6377 2.20161 16.8298 2.61527 16.8594L2.72727 16.8632H13.2727C13.6874 16.8632 14.0866 16.6992 14.3896 16.4044C14.6927 16.1095 14.8771 15.7057 14.9055 15.2746L14.9091 15.1579V8.71579C14.9091 8.56503 14.9666 8.42045 15.0689 8.31386C15.1711 8.20726 15.3099 8.14737 15.4545 8.14737ZM7.90109 0.0090948L7.94982 0.0022737L8.01236 0L8.056 0.00303154L8.12436 0.0151579L8.17382 0.0295579L8.21745 0.0462317L8.26836 0.0735157L8.30546 0.0977684L8.33309 0.118232L8.38545 0.165979L13.0138 4.98922C13.1117 5.09052 13.1691 5.22668 13.1744 5.3703C13.1798 5.51392 13.1328 5.65434 13.0428 5.76327C12.9528 5.87221 12.8266 5.94159 12.6895 5.95743C12.5524 5.97328 12.4147 5.93442 12.304 5.84867L12.2429 5.79335L8.54545 1.94021V12.1263C8.54545 12.2637 8.49771 12.3964 8.41108 12.4999C8.32444 12.6034 8.20477 12.6708 8.07418 12.6894L8 12.6947C7.86819 12.6947 7.74084 12.645 7.64151 12.5547C7.54217 12.4644 7.47756 12.3397 7.45964 12.2036L7.45455 12.1263V1.94021L3.75709 5.79335C3.66474 5.88961 3.5423 5.94814 3.41204 5.9583C3.28177 5.96845 3.15234 5.92955 3.04727 5.84867L2.98618 5.79335C2.89381 5.6971 2.83764 5.56951 2.8279 5.43376C2.81815 5.29802 2.85548 5.16314 2.93309 5.05364L2.98618 4.98922L7.61455 0.166737L7.69455 0.0985264L7.76364 0.0568421L7.82618 0.0303158L7.90109 0.00985264V0.0090948Z"
                                        fill="black"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>

<footer>
    <Footer />
</footer>

<style>
    .circle-text{
        width: 49.008vw;
        font-size: 1.984vw;
        font-weight: 500;
        line-height: 2.401vw;
        color: #00204B;
    }
    .circle-container{
        margin:12vw auto 7vw;
    }
     .circle {
        width: 87.235vw;
        height: 49.669vw;
        padding-top: 5.225vw;
        padding-left: 2.5vw;
        border: 0.199vw solid rgb(124 193 255 / 20%);;
        border-top-right-radius: 1vw;
        border-bottom-right-radius: 1vw;
        border-left: none;
        position: relative;
    }
    .circle::before {
        content: " ";
        position: absolute;
        top: -1.09vw;
        left: 2vw;
        height: 1.919vw;
        width: 1.919vw;
        background-color: rgba(247, 224, 95, 1);
        border-radius: 50%;
    }
    .spotify-div{
        display: flex;
        justify-content: center;
        width: 80.489vw;
        height: 32.011vw;
        margin-top: 3vw;
    }
    .blog_contnet_holder {
        display: flex;
        gap: 1vw 7.548vw;
        flex-wrap: wrap;
    }
    .blog_content_section {
        margin-top: 5vw;
        width: 23.148vw;
    }
    .blog-image-wrraper {
        width: 23.148vw;
        height: 13.228vw;
        overflow: hidden;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    .header {
        padding: 7vw;
    }

    .blog_content_section_mobile {
        margin-top: 7.222vw;
        width: 92vw;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .header {
            padding: 30vw 0 !important;
            text-align: center;
        }
        .spotify-div{
            display: flex;
            justify-content: center;
            width: 90.618vw;
            height: 70.258vw;
            margin-top: 2.984vw;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>
